:host {
  --aha-modal-body--background: var(--theme-primary-background);
  --aha-modal-body--padding-top: var(--spacer-8);
  --aha-modal-body--padding-bottom: var(--spacer-10);
  --aha-modal-body--padding-left: var(--spacer-8);
  --aha-modal-body--padding-right: var(--spacer-8);
  --aha-modal-body--content-padding: var(--spacer-4);
  --aha-modal-body--max-height: calc(100vh - 170px);

  display: block;
  box-sizing: border-box;
  cursor: auto;
  max-height: var(--aha-modal-body--max-height);
  padding: var(--aha-modal-body--padding-top) var(--aha-modal-body--padding-left)
    var(--aha-modal-body--padding-bottom) var(--aha-modal-body--padding-left);
  background: var(--aha-modal-body--background);
  overflow: auto;
}

/* Typically a aha-modal has 3 children, a header, a body, and a footer. In some cases, the footer is not present. In this case, the body will have square corners rather than rounded ones. This rule makes it such that, if the aha-modal-body is the last child of the aha-modal, then it has rounded bottom corners. */
:host(:last-child) {
  border-bottom-left-radius: var(--aha-modal--border-radius);
  border-bottom-right-radius: var(--aha-modal--border-radius);
}

:host([has-left-content]),
:host([has-right-content]) {
  display: flex;
  flex-direction: row;
  padding: 0;
}

:host([has-left-content]) #content::slotted(*),
:host([has-right-content]) #content::slotted(*) {
  padding-left: var(--aha-modal-body--padding-left);
  padding-right: var(--aha-modal-body--padding-right);
}

:host([has-left-content]) #content::slotted(*) {
  padding-left: calc(var(--aha-modal-body--padding-left) / 2);
}

:host([has-right-content]) #content::slotted(*) {
  padding-right: calc(var(--aha-modal-body--padding-right) / 2);
}

:host([has-left-content]) slot::slotted(*),
:host([has-right-content]) slot::slotted(*) {
  padding-top: var(--aha-modal-body--padding-top);
  padding-bottom: var(--aha-modal-body--padding-bottom);
}

slot[name='left-content']::slotted(*) {
  padding-left: var(--aha-modal-body--padding-left);
  padding-right: var(--aha-modal-body--content-padding);
  border-right: solid 1px var(--theme-primary-border);
}

slot[name='right-content']::slotted(*) {
  padding-left: var(--aha-modal-body--content-padding);
  padding-right: var(--aha-modal-body--padding-right);
  border-left: solid 1px var(--theme-primary-border);
}
